<template>
  <div>
      <a href="http://10.246.84.182:8866/collectCards">集卡活动</a>
    <div class="music">
      <div class="bg-music" @click="tapMusic" :class="bgMusicShow?'music-on':'music-off'"></div>
      <audio autoplay preload="auto" loop="loop" ref="bgMusic">
        <source src="./assets/audio/bg.mp3">
      </audio>
    </div>
    <transition-group name="fade" mode="in-out">
      <loadPage :key="1" @next="next" v-if="showFlag === 1"></loadPage>
      <toInterview :chooseMusicFlag="chooseMusic" :key="2" @next="next" v-if="showFlag === 2"></toInterview>
    </transition-group>
    <test :key="3" @next="next" :chooseMusicFlag="chooseMusic" v-if="showFlag === 3"></test>
    <testResult :key="4" @next="next" v-if="showFlag === 4"></testResult>
  </div>
</template>
<script>
// 微信授权
import wxShare from '@utils/wxShare';
import ancientOfferModule from '@page/ancientOffer/store';
import loadPage from './components/loadPage';
import toInterview from './components/toInterview';
import test from './components/test';
import testResult from './components/testResult';

export default {
    components: {
        loadPage,
        toInterview,
        test,
        testResult
    },
    data() {
        return {
            bgMusicShow: true,
            progress: 0,
            showFlag: 1,
            num: 0,
            chooseMusic: true
        };
    },
    mounted() {
        if (/* eslint-disable*/!this.$store._modules.root._children.ancientOffer /* eslint-enable */) {
            this.$store.registerModule('ancientOffer', ancientOfferModule);
        }
        // const that = this;
        // document.addEventListener("touchstart", ()=> {
        //   function musicAutoPlay() {
        //     if (that.$refs.bgMusic) {
        //       that.$refs.bgMusic.play();
        //     }
        //   }
        //   musicAutoPlay();
        // });
        wxShare({
            title: '测测你在古代能拿什么offer？',
            desc: '这班上不下去了，我还是回古代找工作吧……',
            link: `${location.origin}/ancientOffer`,
            imgUrl: 'http://wwj.jijiagames.com//web/act/20190410/share_bg.png'
        }, () => {
            this.$refs.bgMusic.play();
        });
        switch (this.$route.params.source) {
            case 'kzl':
                if (this.$route.query.falg) {
                    /* eslint-disable-next-line */
                    window._hmt.push(['_trackEvent', '市场kzl渠道扫码进入', '市场kzl渠道扫码进入数量量 ', window.location.href]);
                }
                break;
            case 'yxs':
                if (this.$route.query.falg) {
                    /* eslint-disable-next-line */
                    window._hmt.push(['_trackEvent', '市场yxs渠道扫码进入', '市场kzl渠道扫码进入数量量 ', window.location.href]);
                }
                break;
            case 'duomai':
                if (this.$route.query.falg) {
                    /* eslint-disable-next-line */
                    window._hmt.push(['_trackEvent', '市场duomai渠道扫码进入', '市场kzl渠道扫码进入数量量 ', window.location.href]);
                }
                break;
            default:
                if (this.$route.query.falg) {
                    /* eslint-disable-next-line */
                    window._hmt.push(['_trackEvent', '市场default渠道扫码进入', '市场kzl渠道扫码进入数量量 ', window.location.href]);
                }
                break;
        }
    },
    methods: {
        tapMusic() {
            this.bgMusicShow = !this.bgMusicShow;
            if (this.bgMusicShow) {
                this.$refs.bgMusic.play();
                this.chooseMusic = true;
            }
            else {
                this.$refs.bgMusic.pause();
                this.chooseMusic = false;
            }
        },
        next(value) {
            this.showFlag = value;
        }
    }
};
</script>
<style lang="stylus" scoped>
.music, .bg-music {
  position: fixed;
  width: 0.67rem;
  height: 0.67rem;
  top: 0.48rem;
  right: 0.66rem;
  z-index 999
}
.music-on {
  background: url('./assets/img/music_on.png') no-repeat;
  z-index 999
}
.music-off {
  background: url('./assets/img/music_off.png') no-repeat;
  z-index 999
}
.title
  width 2rem
  height 2rem
  background #f66
  font-size: 0.5rem
  border-radius: 50%
  animation: rotate 1.2s linear infinite
  text-align: center
  line-height: 2rem
  color: #fff
  box-shadow: 5px 5px 5px
.progress {
  // position: fixed;
  top: 0.5rem;
  left: 0.5rem;
}
@keyframes rotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.fade-enter {
  opacity: 0;
}
.fade-leave {
  opacity: 1;
}
.fade-enter-active {
  transition: opacity 0.5s;
}
.fade-leave-active
  opacity 0
  transition opacity 0.5s
</style>
